import React from 'react'
import {Col, FormGroup, Input, Label, Row} from "reactstrap";


const statusChangeOptions = {
    "create": {
        "icon": "fa fa-plus",
        "color": "jc-create"
    },
    "update": {
        "icon": "fa fa-refresh",
        "color": "jc-update"
    },
    "delete": {
        "icon": "fa fa-minus",
        "color": "jc-delete"
    },
}

export const JsonViewModes = [
    {id:'FORM',val:'FORM', label:'Formulario'},
    {id:'JSON',val:'JSON', label:'Json'},
    {id:'BOTH',val:'BOTH', label:'Ambos'}
]

const multiDBKeys = ['allDb', 'noDb', 'fbDataBase', 'concreteDataBases']
const keysToIgnore = ['id','lang','uids']

export const compareJsonSortingList = (list = []) => {
    if(list.length === 0)
        return []

    return list.sort( (a,b) => {
        if(a?.id < b?.id)
            return -1

        if(a?.id > b?.id)
            return 1

        return 0
    } )
}

export const compareJsonSortingLangList = (list = []) => {
    if(list.length === 0)
        return []

    return list.sort( (a,b) => {
        if(a?.lang?.id < b?.lang?.id)
            return -1

        if(a?.lang?.id > b?.lang?.id)
            return 1

        return 0
    } )
}

export const getStatusChangeTools = (actualValue, newValue) => {
    const status = getChangeType( actualValue, newValue )
    const options = statusChangeOptions[ status ]
    const { icon, color } = options

    return [icon, color]
}

const getChangeType = (actualValue, newValue) => {
    if(actualValue && !newValue)
        return 'delete'

    if(newValue && !actualValue)
        return 'create'

    return 'update'
}

export const defineFields = (data, sectionTitle = null) => {
    let inputs = []
    const keys = new Set(Object.keys( data ))

    if(sectionTitle)
        inputs.push( getSectionTitle( sectionTitle ) )

    keys.forEach(key => {
        const value = data[ key ]

        if(Array.isArray(value)){
            const keyLang = key.toLowerCase().includes('lang') ? '' : null
            const dataArray = defineFields(value, keyLang)

            if (dataArray.length > 0)
                inputs.push(dataArray)

            return
        }

        if((typeof value === 'object' && value != null )) {
            if(key === 'lang')
                return

            const dataObject = defineFields(value, key)

            if (dataObject.length > 0)
                inputs.push(dataObject)

            return
        }

        inputs.push( getInput( key, value ) )

    })

    return inputs
}

export const defineFieldWithChanges = (model, actualData, newData, sectionTitle= null, isLang = false) => {
    let  inputs = []
    let keys = new Set(Object.keys( actualData ).concat( Object.keys( newData )))

    if(!actualData)
        return []

    if(sectionTitle && !isLang)
        inputs.push( getSectionTitle( sectionTitle ) )

    keys.forEach( (key, index) => {
        const invalid = keysToIgnore.find( e => e == key)
        const isModel = key.toLowerCase() == model.toLowerCase()

        if(!!invalid || isModel)
            return

        const actualValue = actualData?.[key]
        const newValue = newData?.[key]
        const areEquals = actualValue === newValue

        if(areEquals)
            return

        if(Array.isArray(actualValue) || Array.isArray(newValue)){
            let isLangArray = key == "langs"
            let actualValuesList = isLangArray ? compareJsonSortingLangList(actualValue) :  compareJsonSortingList(actualValue)
            let newValuesList = isLangArray ? compareJsonSortingLangList(newValue) :  compareJsonSortingList(newValue)

            let dataArray = defineFieldWithChanges(
                model,
                actualValuesList,
                newValuesList,
                key,
                isLangArray
            )

            if(dataArray.length > 0)
                inputs.push( dataArray )

            return
        }

        if((typeof actualValue === 'object' && actualValue != null) || (typeof newValue === 'object' && newValue != null)) {
            const title = isLang
                ?  actualValue?.lang ? actualValue?.lang?.name : newValue?.lang?.name
                : key

            let dataObject = defineFieldWithChanges(model,actualValue || {}, newValue ||{}, title)

            if(dataObject.length > 1)
                inputs.push( dataObject )

            return
        }

        inputs.push( getInputs( key, actualValue, newValue ) )
    })

    return inputs
}

const getSectionTitle = title => <div key={ title } className={ 'mt-5' }>
    <h4>{ title }</h4>
    <hr />
</div>

const getInput = (title, content) => <Row key={title}>
    <Col>
        <FormGroup className='input-wrapper'>
            <Label>{ title }</Label>
            <Input
                type="text"
                name={ title }
                value={ content || '' }
                readOnly={ true }
            />
        </FormGroup>
    </Col>
</Row>

const getInputs = (title, content, newContent) => {
    const [ icon, color] = getStatusChangeTools(content, newContent)

    return <Row key={title}>
        <Col sm={2}>
            {title}
        </Col>
        <Col>
            <div className='input-wrapper'>
                <FormGroup><Input
                    type="text"
                    name={title}
                    readOnly={true}
                    value={content || ''}
                /></FormGroup>
            </div>
        </Col>
        <Col>
            <div className='input-wrapper'>
                <Input
                    className={ color }
                    type="text"
                    name={title}
                    readOnly={true}
                    value={newContent || ''}
                />
                <i className={ `${icon} ${color}` } />
            </div>
        </Col>
    </Row>
}

export const isMultiDBObject = data => {
    if(!data)
        return false

    let output = false
    const keys = new Set(Object.keys( data ))

    for( const mdb of multiDBKeys ){
        if (keys.has(mdb)){
            output = true
            break;
        }
    }

    return output
}
